import  './Heading.css';
export default function Heading() {
  return (
   <div className="top-focus">
    <div className="container focus-table">
      <h1><strong>Our Clients</strong></h1>
    </div>
    </div>
  );
}
